var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bc-black",attrs:{"id":"features-page"}},[_c('div',{staticClass:"w-100 c-max-w"},[_c('router-view')],1),_c('FooterCTA',{attrs:{"overline":"GET STARTED","title-html":"Upgrade <span class='grey'>your demo inbox</span>","button-text":"CREATE ACCOUNT","button-to":"/sign_up"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }